module.exports = __webpack_public_path__ + "components/home-header/static/header-7--medium-36d678961690578ee80b5045788507a9.jpg";